import axios from 'axios';
import { useState, Dispatch, useRef } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { ProgressListItem } from '@salecycle/ui-component-library';
import { IUploadFile } from './UploadFileList';

interface ProgressEvent {
  loaded: number;
  total: number;
}

interface IProps extends IUploadFile {
  onComplete: Dispatch<number>;
}

export function UploadFile({ fileKey, fileName, fileData, signedUrl, onComplete }: IProps) {
  const { t } = useTranslation('fileManagement');
  const [progress, setProgress] = useState(0);

  const onUploadProgress = (progressEvent: ProgressEvent) => {
    const currentProgress = (progressEvent.loaded / progressEvent.total) * 100;
    setProgress(currentProgress);
    if (currentProgress === 100) {
      onComplete(null);
    }
  };

  const csv = useRef(new File([fileData], fileName, { type: 'application/csv' }));
  const start = useRef(new Date());

  const { isError, refetch } = useQuery(
    signedUrl,
    async () => await axios.put(signedUrl, csv.current, { onUploadProgress }),
    {
      retry: false,
    },
  );

  let failure;
  if (isError) {
    failure = {
      message: t('upload.error.failure'),
      retry: {
        callback: () => {
          start.current = new Date();
          refetch();
        },
      },
    };
  }

  return (
    <ProgressListItem
      subject={fileName}
      progress={progress}
      rate={{
        totalBytes: csv.current.size,
        start: start.current,
      }}
      failure={failure}
    />
  );
}
